exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".avatarImg[data-v-9c0b05b0] {\n  height: 40px;\n}\n.my-box .el-row[data-v-9c0b05b0] {\n  margin-bottom: 10px;\n}\n.my-box .el-row[data-v-9c0b05b0]:last-child {\n    margin-bottom: 0;\n}\n.my-box .el-col[data-v-9c0b05b0] {\n  border-radius: 4px;\n}\n.my-box .my-input[data-v-9c0b05b0] {\n  max-width: 209px;\n}\n.checkBox[data-v-9c0b05b0] {\n  display: inline-block;\n  width: 28%;\n}\n", ""]);

// exports
